<template>
  <v-hover>
    <template #default="{ hover }">
      <v-card
          class="tools-card"
          color="#2E5D90"
          :class="hover ? 'tools-card-show' : 'tools-card-hide'"
          :height="170"
          :width="70"
      >
        <general-tools-list :hover="hover"></general-tools-list>
      </v-card>
    </template>
  </v-hover>
</template>

<script>
import GeneralToolsList from "@/views/Tools/Global/GeneralToolsList";

export default {
  name: "GeneralToolsGlobalCard",
  components: {
    GeneralToolsList,
  },
}
</script>

<style scoped>
.tools-card {
  z-index: 202;
  position: absolute;
  transition: all 0.2s;
  border-radius: 0 0 8px 8px !important;
  left: 330px;
}

.tools-card-hide {
  top: -140px;
}

.tools-card-show {
  top: 0;
}
</style>